import React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { AddButton } from "cm-component-library/lib/CMLayout/Navbar/";
import { Button } from "reactstrap";
import queryString from "query-string";
import { appPaths } from "../../Common";
import { AddFeedbackButtonType } from "../Constants/LayoutEnums";
import "../Styles/AddFeedbackButton.scss";

type Props = {
  type: AddFeedbackButtonType;
};

const CLASSNAME_PREFIX = "AddFeedbackButton__";

class AddFeedbackButton extends React.Component<RouteComponentProps & Props> {
  handleClick = () => {
    const queryArgs = {
      type: this.props.location.pathname.includes("/bugreports") ? "bug" : "feature"
    };

    const stringified = queryString.stringify(queryArgs);

    this.props.history.push(`${appPaths.feedback.submitFeedback}?${stringified}`);
  };

  render() {
    switch (this.props.type) {
      case AddFeedbackButtonType.Icon:
        return <AddButton onClick={this.handleClick} />;
      case AddFeedbackButtonType.Button:
        return (
          <span className={`${CLASSNAME_PREFIX}button`} onClick={this.handleClick}>
            Add Feedback
          </span>
        );
      default:
        throw new Error(`Invalid button type ${this.props.type}`);
    }
  }
}

export default withRouter(AddFeedbackButton);
